import React from 'react';

const ExtraHeaderRight = () => {
  return <></>;
};

export default ExtraHeaderRight;
